// tempoWorker.js

// adapted from:
// Copyright (c) 2023 Project Nayuki
// All rights reserved. Contact Nayuki for licensing.
// https://www.nayuki.io/page/tap-to-measure-tempo-javascript

"use strict";

let beatTimes = [];
let xSum = 0;
let xxSum = 0;
let ySum = 0;
let yySum = 0;
let xySum = 0;
let periodPrev = NaN;
let aPrev = NaN;
let bPrev = NaN;

onmessage = function (event) {
    const { cmd, tapTimes } = event.data;

    if (cmd === 'calculateTempo') {
        beatTimes = tapTimes;

        if (beatTimes.length >= 2) {
            const n = beatTimes.length;
            const x = n - 1;
            const y = beatTimes[n - 1] - beatTimes[0];

            // Regression cumulative variables
            xSum += x;
            xxSum += x * x;
            ySum += y;
            yySum += y * y;
            xySum += x * y;

            // Calculate tempo
            const period = y / x;
            const tempo = 60000 * x / y;

            let advancedTempo = null;

            if (n >= 2) {
                const xx = n * xxSum - xSum * xSum;
                const a = (n * xySum - xSum * ySum) / xx;

                advancedTempo = 60000 / a;

                periodPrev = period;
                aPrev = a;
            }

            console.log(`Tempo: ${tempo.toFixed(2)} BPM`);

            // Send tempo estimate back to main thread
            postMessage({
                type: 'tempoCalculated',
                tempo: tempo.toFixed(2),
                advancedTempo: advancedTempo ? advancedTempo.toFixed(3) : null
            });
        }
    } else if (cmd === 'reset') {
        resetState();
    }
};

// Reset internal state
function resetState() {
    beatTimes = [];
    xSum = 0;
    xxSum = 0;
    ySum = 0;
    yySum = 0;
    xySum = 0;
    periodPrev = NaN;
    aPrev = NaN;
    bPrev = NaN;
}
